import Link from 'next/link'

export const Navbar = () => {
  return (
    <div className="navbar fr">
      <Link href="/" legacyBehavior>
        {/* biome-ignore lint/a11y/useValidAnchor: Handled by Next.js */}
        <a className="title tab">MoneyCoach</a>
      </Link>
      <Link href="/videos" legacyBehavior>
        {/* biome-ignore lint/a11y/useValidAnchor: Handled by Next.js */}
        <a className="tab">Videos</a>
      </Link>
      <Link href="/recommendations" legacyBehavior>
        {/* biome-ignore lint/a11y/useValidAnchor: Handled by Next.js */}
        <a className="tab">Products</a>
      </Link>
      <Link href="/calculators" legacyBehavior>
        {/* biome-ignore lint/a11y/useValidAnchor: Handled by Next.js */}
        <a className="final tab">Calculators</a>
      </Link>
    </div>
  )
}
